export default "__VITE_ASSET__C5ZMf3FO__"